<div class="promocodes-container">
    <p-toast></p-toast>

    <div *ngIf="!isLoading">
        <div class="header-section">
            <div class="title-group">
                <h1>Promo Codes</h1>
                <p>Manage discount coupons and offers</p>
            </div>
            <p-button label="Add Promo Code" icon="pi pi-plus" (click)="addPromoCode()" styleClass="add-btn"></p-button>
        </div>


        <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2 mb-5">
            <div class="flex align-items-center justify-content-between">
                <h2 class="text-left font-medium text-2xl" style="color: #303030;">Search</h2>
            </div>
            <form [formGroup]="filterForm" (ngSubmit)="onSearch()" class="w-full flex flex-wrap align-items-center">
                <div class="w-full grid">
                    <div class="col-12 sm:col-6 md:col-4 xl:col-4
                 flex flex-column gap-2">
                        <b class="font-regular text-base" style="color: #505050;">Code</b>
                        <p-autoComplete placeholder="Code" formControlName="code" [suggestions]="names"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('code')?.value}"
                            class="w-full" [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}"
                            (completeMethod)="filterNames($event)" styleClass="fullWidth" field="name" [minLength]="3"
                            appendTo="body">
                        </p-autoComplete>
                    </div>

                    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                        <b class="font-regular text-base" style="color: #505050;">Status</b>
                        <p-dropdown [options]="stateOptions" [showClear]="true" optionValue="value"
                            styleClass="selectFull" [style]="{'width': '100%'}"
                            [ngClass]="{'ng-invalid ng-dirty' : submitted && ! filterForm.get('promoStatus')?.value}"
                            formControlName="promoStatus" optionLabel="name" class="w-full"
                            placeholder="Active/Inactive" />
                    </div>


                    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                        <div style="padding-top: 23px;">
                            <p-button type="submit" label="Search" styleClass="submitBtn"
                                [style]="{'background-color': '#000086', 'border': 'none', 'box-shadow': 'none', 'outline': 'none'}" />
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div style="position: relative; min-height: 200px;">
            <div *ngIf="isSearchLoading" class="flex align-items-center justify-content-center"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255, 255, 255, 0.7); z-index: 10; backdrop-filter: blur(2px);">
                <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: #303030;"></i>
            </div>

            <div class="table-container" *ngIf="filteredPromoCodes().length > 0; else noRecordsFound">

                <div class="table-header">
                    <div class="header-col code">Code</div>
                    <div class="header-col type">Type</div>
                    <div class="header-col value">Value</div>
                    <div class="header-col usage">Usage</div>
                    <div class="header-col validity">Validity</div>
                    <div class="header-col status">Status</div>
                    <div class="header-col actions">Actions</div>
                </div>

                <div class="table-row" *ngFor="let promo of filteredPromoCodes() | slice:first:first+rows">
                    <div class="table-col code" data-label="Code">
                        <span class="code-text" [title]="promo.description">{{ promo.code }}</span>
                        <button class="copy-btn" (click)="copyCode(promo.code)" title="Copy Code">
                            <i class="pi pi-copy"></i>
                        </button>
                    </div>

                    <div class="table-col type" data-label="Type">
                        <span class="type-badge" [class.percentage]="promo.type === 0"
                            [class.fixed-amount]="promo.type === 1">
                            {{ getTypeLabel(promo.type) }}
                        </span>
                    </div>

                    <div class="table-col value" data-label="Value">
                        <span class="value-text">{{ promo.value }}</span>
                    </div>

                    <div class="table-col usage" data-label="Usage">
                        <div class="usage-info">
                            <span>{{ promo.usageCount || 0 }}/{{ promo.usageLimit }}</span>
                            <div class="progress-bar">
                                <div class="progress-fill"
                                    [style.width.%]="getUsagePercentage(promo.usageCount || 0, promo.usageLimit)"></div>
                            </div>
                        </div>
                    </div>

                    <div class="table-col validity" data-label="Validity">
                        <span>{{ promo.validityTo | date:'mediumDate' }}</span>
                    </div>

                    <div class="table-col status" data-label="Status">
                        <span class="status-badge" [class.active]="promo.status === 'Active' || promo.isActive"
                            [class.expired]="promo.status === 'Expired' || !promo.isActive">
                            {{ promo.status || (promo.isActive ? 'Active' : 'Inactive') }}
                        </span>
                    </div>

                    <div class="table-col actions">
                        <p-button [icon]="(promo.status === 'Active' || promo.isActive) ? 'pi pi-times' : 'pi pi-check'"
                            (click)="toggleStatus(promo)" [text]="true" [rounded]="true"
                            [severity]="(promo.status === 'Active' || promo.isActive) ? 'danger' : 'success'"
                            styleClass="p-button-text"
                            [pTooltip]="(promo.status === 'Active' || promo.isActive) ? 'Deactivate' : 'Activate'"
                            tooltipPosition="top">
                        </p-button>
                        <p-button icon="pi pi-pencil" (click)="editPromoCode(promo)" [text]="true" [rounded]="true"
                            severity="secondary" styleClass="p-button-text" pTooltip="Edit" tooltipPosition="top">
                        </p-button>
                    </div>
                </div>

                <div class="paginator-container mt-3">
                    <p-paginator [rows]="rows" [totalRecords]="filteredPromoCodes().length" [first]="first"
                        [rowsPerPageOptions]="[10, 20, 30]" (onPageChange)="onPageChange($event)"
                        [showCurrentPageReport]="true" currentPageReportTemplate="{currentPage} of {totalPages}"
                        layout="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown">
                    </p-paginator>
                </div>
            </div>

            <ng-template #noRecordsFound>
                <div class="w-full flex flex-column align-items-center py-4 gap-5">
                    <div class="w-full flex align-items-center justify-content-center">
                        <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
                    </div>
                    <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
                </div>
            </ng-template>
        </div>
    </div>
    <div *ngIf="isLoading" class="flex gap-4 align-items-center justify-content-center py-5">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)"
            animationDuration=".5s"></p-progressSpinner>
    </div>
</div>

<p-dialog [header]="isEditMode ? 'Edit Promo Code' : 'Add Promo Code'" [(visible)]="displayDialog" [modal]="true"
    [style]="{width: '500px'}" [draggable]="false" [resizable]="false">

    <form [formGroup]="promoForm">
        <div class="form-grid">
            <div class="field">
                <label>Code <span class="required">*</span></label>
                <input type="text" pInputText formControlName="code" placeholder="Enter Code"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && code?.invalid}">
                <small class="p-error" *ngIf="submitted && code?.errors?.['required']">
                    Code is required
                </small>
                <small class="p-error" *ngIf="submitted && code?.errors?.['minlength']">
                    Code must be at least 3 characters
                </small>
            </div>

            <div class="field">
                <label>Type <span class="required">*</span></label>
                <p-dropdown [options]="types" formControlName="type" appendTo="body" [style]="{'width':'100%'}"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && type?.invalid}"></p-dropdown>
                <small class="p-error" *ngIf="submitted && type?.errors?.['required']">
                    Type is required
                </small>
            </div>

            <div class="field" style="grid-column: 1 / -1;">
                <label>Description</label>
                <textarea pInputTextarea rows="3" formControlName="description" placeholder="Enter Description"
                    class="w-full"></textarea>
            </div>

            <div class="field">
                <label>Value <span class="required">*</span></label>
                <p-inputNumber formControlName="value" [style]="{'width':'100%'}" placeholder="Enter Value"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && value?.invalid}"></p-inputNumber>
                <small class="p-error" *ngIf="submitted && value?.errors?.['required']">
                    Value is required
                </small>
                <small class="p-error" *ngIf="submitted && value?.errors?.['min']">
                    Value must be greater than 0
                </small>
                <small class="p-error" *ngIf="submitted && value?.errors?.['maxPercentage']">
                    Percentage discount cannot exceed 100%
                </small>
            </div>

            <div class="field">
                <label>Usage Limit <span class="required">*</span></label>
                <p-inputNumber formControlName="usageLimit" [min]="1" [style]="{'width':'100%'}"
                    placeholder="Enter Usage Limit"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && usageLimit?.invalid}"></p-inputNumber>
                <small class="p-error" *ngIf="submitted && usageLimit?.errors?.['required']">
                    Usage limit is required
                </small>
                <small class="p-error" *ngIf="submitted && usageLimit?.errors?.['min']">
                    Usage limit must be at least 1
                </small>
            </div>

            <div class="field">
                <label>Validity From <span class="required">*</span></label>
                <input type="date" pInputText formControlName="validityFrom" class="w-full p-inputtext p-component"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && validityFrom?.invalid}">
                <small class="p-error" *ngIf="submitted && validityFrom?.errors?.['required']">
                    Validity from date is required
                </small>
            </div>

            <div class="field">
                <label>Validity To <span class="required">*</span></label>
                <input type="date" pInputText formControlName="validityTo" class="w-full p-inputtext p-component"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && (validityTo?.invalid || promoForm.errors?.['dateRange'])}">
                <small class="p-error" *ngIf="submitted && validityTo?.errors?.['required']">
                    Validity to date is required
                </small>
                <small class="p-error" *ngIf="submitted && promoForm.errors?.['dateRange']">
                    Validity To date must be after Validity From date
                </small>
            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <p-button label="Cancel" (click)="displayDialog = false; submitted = false"
            styleClass="p-button-text"></p-button>
        <p-button [label]="isEditMode ? 'Update' : 'Save'" (click)="savePromoCode()"
            [disabled]="submitted && promoForm.invalid" styleClass="add-btn"></p-button>
    </ng-template>
</p-dialog>